// extracted by mini-css-extract-plugin
module.exports = {"statement":"statement_statement_QNlGX","container":"statement_container_1xQdH","chartWrap":"statement_chartWrap_JB_Gj","title":"statement_title_afL3b","btn":"statement_btn_3zIaY"};